import { Brand, PartialTheme } from '@evenfinancial/even-ts-static'

import { getBrandObject } from 'embed/utils'
import { brandFromHost } from 'embed/constants/config'

export const DEFAULT_THEME: PartialTheme = {
  ...getBrandObject(brandFromHost).defaultTheme,
  ...(brandFromHost === Brand.Even
    ? {
        colorBackgroundSecondary: '#f8f7fc',
        colorPrimary: '#66a9f4',
        colorSecondary: '#66a9f4',
        ctaStyles: { backgroundColor: '#36d386' },
        errorStyles: { color: '#e69575' },
      }
    : {}),
}
